module.exports = __webpack_public_path__ + "img/fh_slider2.8cb6b17f.jpg";